export class Message {
    showCloseButton;
    content;
    title;
    callback;
    constructor(content, title, callback, showCloseButton) {
        this.showCloseButton = showCloseButton;
        this.content = content;
        this.title = title;
        this.callback = callback;
    }
}
